import React from "react";
import { Route, Routes } from "react-router-dom";

import LayOut from "./components/admin/layOut";
import LogIn from "./components/admin/logIn";

function App() {
  return (
    <div className="App font-IRANSansWeb">
      <Routes>
        <Route
          path="/admin/*"
          element={<LayOut render={(props) => ({ ...props })} />}
        />
        <Route
          path="/*"
          element={<LogIn render={(props) => ({ ...props })} />}
        />

        {/* <Route path="/" element={<LogIn />} /> */}
        {/* <Route exact path="/admin/*" element={<LayOut />} /> */}

        {/* <Route path="*" element={<Page404 />} /> */}
      </Routes>
    </div>
  );
}

export default App;
